import { render, staticRenderFns } from "./SourceTypes.vue?vue&type=template&id=4dcc3895"
import script from "./SourceTypes.vue?vue&type=script&lang=js"
export * from "./SourceTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports